import { Download, X } from 'lucide-react';
import usePWAInstall from '@/hooks/usePWAInstall';

export default function PWAInstallBanner() {
  const { canShow, install, dismiss } = usePWAInstall();

  if (!canShow) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="mx-4 mt-3 flex items-center gap-3 p-3 rounded-xl bg-zinc-900 border border-zinc-800/50 animate-fade-in"
    >
      <div className="w-9 h-9 rounded-lg bg-[#E84C1C]/10 flex items-center justify-center shrink-0">
        <Download size={18} className="text-[#E84C1C]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">Instalar Sushi Express</p>
        <p className="text-xs text-zinc-400 truncate">Acceso rápido desde tu pantalla de inicio</p>
      </div>
      <button
        data-testid="pwa-install-btn"
        onClick={install}
        className="shrink-0 px-3 py-1.5 text-xs font-medium bg-[#E84C1C] hover:bg-[#d4411a] rounded-lg transition-colors"
      >
        Instalar
      </button>
      <button
        data-testid="pwa-dismiss-btn"
        onClick={dismiss}
        className="shrink-0 text-zinc-500 hover:text-zinc-300 transition-colors"
      >
        <X size={16} />
      </button>
    </div>
  );
}
